var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPumpNDumpLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("pattern", {
    y: 0,
    x: 0,
    height: 6,
    width: 6,
    patternUnits: "userSpaceOnUse",
    id: "EMFhbasepattern"
  }), /*#__PURE__*/React.createElement("pattern", {
    y: 0,
    x: 0,
    height: 6,
    width: 6,
    patternUnits: "userSpaceOnUse",
    id: "EMFhbasepattern-8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-1036.3622)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "M 7.8242188 3 L 5.578125 3.1152344 C 6.3925392 3.9296479 6.3092414 3.850071 6.3789062 3.921875 L 4.296875 6.0039062 L 5.0039062 6.7109375 L 7.0839844 4.6308594 C 7.1547349 4.703731 7.0711405 4.621944 7.8828125 5.4335938 L 7.8847656 5.4335938 L 8 3.1757812 C 8.0055 3.0757813 7.9238457 2.9946 7.8242188 3 z M 11.5 3 C 11.223 3 11 3.223 11 3.5 L 11 12.5 C 11 12.777 11.223 13 11.5 13 L 13.5 13 C 13.777 13 14 12.777 14 12.5 L 14 3.5 C 14 3.223 13.777 3 13.5 3 L 11.5 3 z M 7.5 6 C 7.223 6 7 6.223 7 6.5 L 7 12.5 C 7 12.777 7.223 13 7.5 13 L 9.5 13 C 9.777 13 10 12.777 10 12.5 L 10 6.5 C 10 6.223 9.777 6 9.5 6 L 7.5 6 z M 3.625 8 C 3.27875 8 3 8.2787 3 8.625 L 3 12.375 C 3 12.7212 3.27875 13 3.625 13 L 5.375 13 C 5.72125 13 6 12.7212 6 12.375 L 6 8.625 C 6 8.2787 5.72125 8 5.375 8 L 3.625 8 z ",
    transform: "translate(0,1036.3622)",
    id: "rect4784"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpNDumpLogo);
export default __webpack_public_path__ + "static/media/pump_n_dump_logo.2333f86696d87fb130ee44df12c31af4.svg";
export { ForwardRef as ReactComponent };